<script>
import {api} from "@/modules/api";
import InputField from "@/components/input/InputField.vue";
import {useAuthStore} from "@/stores/auth";
import {mapStores} from "pinia";
import RadioField from "@/components/input/RadioField.vue";
import ModalAddress from "@/components/profil/address/ModalAddress.vue";

export default {
  name: 'DeliveryInformations',
  components: {ModalAddress, RadioField, InputField},
  data () {
    return {
      formData: {},
      deliveryInformation: {},
      viewModal: false
    }
  },
  mounted () {
    this.loadData()
    this.emitter.on('load-data', () => {
      this.loadData()
    })
  },
  computed: {
    ...mapStores(useAuthStore)
  },
  methods: {
    useAuthStore,
    loadData () {
      api.profil.getDeliveryInformation().then((res) => {
        this.deliveryInformation = res
        this.deliveryInformation.completeName = this.deliveryInformation.lastname + ' ' + this.deliveryInformation.firstname
        const address = this.deliveryInformation.Address.filter(address => {
          return address.isMain
        })
        this.formData.selectedAddress = address[0].id
        this.emitter.emit('delivery-address', this.formData.selectedAddress)
      })
    }
  }
}
</script>

<template>
  <div class="space-y-4">
    <h2 class="text-xl font-semibold text-gray-900 dark:text-white">Informations de livraison</h2>

    <div class="grid grid-cols-1 gap-4 sm:grid-cols-2">
      <input-field
        v-model="deliveryInformation.email"
        label="Votre email"
        :disable="authStore.isConnected"
      />
      <input-field
          v-model="deliveryInformation.completeName"
          label="Votre nom"
          :disable="authStore.isConnected"
      />
      <div>
        <h2 class="text-lg font-semibold text-gray-900 dark:text-white">Mes adresses</h2>
        <radio-field
            v-model="formData.selectedAddress"
            :options="deliveryInformation.Address"
            @input="emitter.emit('delivery-address', formData.selectedAddress)"
        />
      </div>
      <div class="sm:col-span-2">
        <button @click="viewModal = true" class="flex w-full items-center justify-center gap-2 rounded-lg border border-gray-200 bg-white px-5 py-2.5 text-sm font-medium text-gray-900 hover:bg-gray-100 hover:text-primary-700 focus:z-10 focus:outline-none focus:ring-4 focus:ring-gray-100 dark:border-gray-600 dark:bg-gray-800 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white dark:focus:ring-gray-700">
          <svg class="h-5 w-5" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
            <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 12h14m-7 7V5" />
          </svg>
          Ajouter nouvelle adresse
        </button>
      </div>
      <modal-address v-if="viewModal" @close-modal="viewModal = false" />
    </div>
  </div>
</template>
